import React from "react";
import DateFnsUtils from "@date-io/moment";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import moment from "moment";
const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
        textAlign: "center",
        color: "red",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});

const TimePickerCustom = (props) => {
  return (
    <div className="row justify-content-center">
      <div className="col-md-4">
        {props.isOpen ? (
          <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider
              libInstance={moment}
              utils={DateFnsUtils}
            >
              <TimePicker
                ampm={false}
                value={props.time}
                onChange={props.handleChangeDate}
                format={"HH[h]mm"}
                disabled={props.onlyView}
              />
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default TimePickerCustom;
